import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-service",
  "use": "icon-service-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-service\">\r\n<path d=\"M63.3,17.2c-19.8,0-35.8,15.7-35.8,35c0,19.3,16,35,35.8,35c19.8,0,35.8-15.7,35.8-35C99.1,32.9,83.1,17.2,63.3,17.2\r\n\tL63.3,17.2z\" />\r\n<path d=\"M22,65.7V33.3c-0.5,0-0.9,0-1.3,0.1c7.3-15.9,23.6-27,42.6-27c19,0,35.3,11.1,42.6,27c-0.4,0-0.9-0.1-1.3-0.1v32.3\r\n\tc9.1,0,16.5-7.2,16.5-16.2c0-6.1-3.4-11.3-8.5-14.1C105.6,15.4,86.2,1,63.3,1C40.5,1,21.1,15.4,14,35.4c-5,2.8-8.5,8-8.5,14.1\r\n\tC5.5,58.4,12.9,65.7,22,65.7L22,65.7z\" />\r\n<path d=\"M99,84.2C89.7,92.7,77.1,98,63.3,98C49.5,98,37,92.7,27.7,84.2C11,92.7,0,107.6,0,128h127.1C127.1,107.6,115.9,92.6,99,84.2\r\n\tL99,84.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/service.svg
// module id = nCjf
// module chunks = 225